import { Button, Modal } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { FC, useState } from 'react';

const OutOfDateHeatLossWarning: FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        variant="quaternary"
        colour="negative"
        size="xs"
        aria-label="Out of date heat loss warning"
        onClick={() => setIsModalOpen(true)}
      >
        <UntitledIcon name="alert-triangle.3" className="size-4" />
      </Button>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Heat loss out of date"
      >
        <Modal.Body>
          <p>
            The project's heat loss calculation has been updated since this
            estimate was created. Create a new estimate to use the latest
            figures.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Modal.Footer.Actions>
            <Button onClick={() => setIsModalOpen(false)}>Ok</Button>
          </Modal.Footer.Actions>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OutOfDateHeatLossWarning;
